// project import
import other from './other';
import pages from './pages';
// import { pagesForStore } from './pages';
import configuration from './setting';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [pages]
};

export const menuItemsForAdmin: { items: NavItemType[] } = {
    items: [pages, configuration]
};

export default menuItems;
